import _ from 'lodash';
import Autocomplete from 'react-autocomplete';
import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

const HookAutocompleteFormControl = (props: any) => {
    const { name, label, defaultValue, rules, type, onChange, onSelect, ...rest } = props;
    const form = useFormContext();

    const isError = _.get(form.formState.errors, name);

    return (
        <div className="autocomplete">
            {label && (
                <Form.Label>
                    {label}
                    {rules?.required && <span className="required-mark" />}
                </Form.Label>
            )}
            <Controller
                name={name}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        {...rest}
                        value={field.value}
                        onSelect={(val, item) => {
                            field.onChange(val);
                            if (props.onSelect) {
                                props.onSelect(val, item);
                            }
                        }}
                        onChange={(value) => {
                            field.onChange(value);
                            if (props.onChange) {
                                props.onChange(value);
                            }
                        }}
                        className="form-control autocomplete-wrapper"
                        inputProps={{
                            style: {
                                height: `46px`,
                                lineHeight: `30px`,
                                padding: `8px 16px,`,
                                borderColor: isError ? '#dc3545' : '#ced4da',
                                backgroundColor: isError ? '#dc354520' : '#fff',
                            },
                            placeholder: rest.placeholder,
                            name: name,
                            className: 'form-control-autocomplete',
                            disabled: props.disabled || false,
                            maxLength: rest.maxLength || 60,
                        }}
                    />
                )}
                control={form.control}
                defaultValue={defaultValue || ''}
                rules={rules}
            />
            <Form.Control.Feedback type="invalid">
                {(_.get(form.formState.errors, name) as FieldError)?.message}
            </Form.Control.Feedback>
        </div>
    );
};

export default HookAutocompleteFormControl;
